<!-- ======== ABOUT SECTION ======== -->
<section id="about" class="about-section">
  <h2>About Us</h2>

  <div class="about-card">
    <div class="about-text">
      <p>
        Welcome to <strong>ASAPP Software Solutions</strong>, a dynamic and innovative software company dedicated to
        transforming ideas into powerful digital solutions.
        <br><br>
        Founded on <strong>7th November 2025</strong>, we specialize in designing, developing, and delivering
        cutting-edge software products tailored to meet diverse business needs.
        <br><br>
        We are proud to be both a <strong>service-based</strong> and <strong>product-based</strong> company, offering
        a wide range of custom software development, web and mobile applications, cloud solutions, and enterprise-grade systems.
        <br><br>
        Our goal is to empower businesses of all sizes with technology that drives growth, efficiency, and success.
      </p>
    </div>

    <div class="about-image">
      <img
        src="assets/about_us.png"
        alt="About ASAPP Software Solutions">
    </div>
  </div>
</section>
